import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type AgentOnlineProps = {
  entry: UserAuditLogEntry<'AGENT_ONLINE'>;
};

export const AgentOnline = ({ entry }: AgentOnlineProps): JSX.Element => {
  return (
    <UserActivityCard
      entry={entry}
      color={statusColors.info}
      icon="sign-in"
      title="Online"
    />
  );
};
